export const BLACKLIST_XHR_URL = [
  'amplitude.com',
  'clarity.ms',
  'doubleclick.net',
  'google-analytics.com',
];
